// extracted by mini-css-extract-plugin
export default {"container":"container-OPlBt","paginationContainer":"paginationContainer-aey7x","sliderContainer":"sliderContainer-yK6_8","item":"item-nY1la"};